import apiClient from '../utils/apiClient';

export async function createLead({
  client_name,
  client_company,
  project_name,
  email,
  phone_number,
  description,
  budget_cost,
  budget_hours,
  location,
  address,
  action_id
}) {
  const response = await apiClient.post('/api/leads/', {
    client_name,
    client_company,
    project_name,
    email,
    phone_number,
    description,
    budget_cost,
    budget_hours,
    location,
    address,
    action_id
  });
  return response.data;
}

export async function getLeads() {
  const response = await apiClient.get('/api/leads/');
  return response.data;
}

export async function updateLead(lead_id, updatedFields) {
  const response = await apiClient.put(`/api/leads/${lead_id}`, updatedFields);
  return response.data;
}

export const acceptLeadAndCreateProject = async (leadId) => {
  const response = await apiClient.post(`/api/leads/${leadId}/accept`);
  return response.data;
};

export async function getClientSuggestions(query) {
  if (!query || query.length < 1) return [];

  try {
    const response = await apiClient.get('/api/leads/client-suggestions', {
      params: { query }
    });
    return response.data; // Expected shape: [{ client_company, client_name }]
  } catch (err) {
    console.error("getClientSuggestions error:", err);
    return [];
  }
}

export async function getAllClientCompanies() {
  try {
    const response = await apiClient.get('/api/leads/client-companies');
    return response.data; // Expected shape: [{ client_company_id, company_name }]
  } catch (err) {
    console.error("getAllClientCompanies error:", err);
    return [];
  }
}

export async function getClientContacts(clientCompanyId = null) {
  try {
    const params = {};
    if (clientCompanyId) params.client_company_id = clientCompanyId;
    
    const response = await apiClient.get('/api/leads/client-contacts', { params });
    return response.data; // Expected shape: [{ client_contact_id, name, email, phone_number, company_name }]
  } catch (err) {
    console.error("getClientContacts error:", err);
    return [];
  }
}

export async function deleteLead(leadId) {
  await apiClient.delete(`/api/leads/${leadId}`);
  return true;
}

// Export leads to CSV
export async function exportLeads(params = {}) {
    const response = await apiClient.get('/api/leads/export', {
        params,
        responseType: 'blob' // Important for file downloads
    });

    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `leads_export_${new Date().toISOString().split('T')[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return response.data;
}

// ─── Lead Actions API ──────────────────────────────────────────────

export async function getLeadActions() {
  try {
    const response = await apiClient.get('/api/leads/lead-actions');
    return response.data;
  } catch (error) {
    console.error("Error fetching lead actions:", error);
    throw error;
  }
}

export async function createLeadAction({ name, color, description }) {
  const response = await apiClient.post('/api/leads/lead-actions', { name, color, description });
  return response.data;
}

export async function updateLeadAction(actionId, { name, color, description }) {
  const response = await apiClient.put(`/api/leads/lead-actions/${actionId}`, { name, color, description });
  return response.data;
}

export async function deleteLeadAction(actionId) {
  const response = await apiClient.delete(`/api/leads/lead-actions/${actionId}`);
  return response.data;
}

export async function reorderLeadActions(actionIds) {
  const response = await apiClient.put('/api/leads/lead-actions/reorder', { actionIds });
  return response.data;
}

// ─── Lead Assignments API ──────────────────────────────────────────

export async function getLeadAssignments(leadId) {
  const response = await apiClient.get(`/api/leads/${leadId}/assignments`);
  return response.data;
}

export async function assignEmployeesToLead(leadId, { assignedBy, employees }) {
  const response = await apiClient.post(`/api/leads/${leadId}/assign`, {
    leadId,
    assignedBy,
    employees,
  });
  return response.data;
}

